module.exports = __webpack_public_path__ + "static/media/cf4b31b3-06ba-440c-b262-8802f4ecc956_1.3660c0fd55dd0d2b1e85ad7d66ff902c.68df0ea6.jpeg";